import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { YouSpinner } from '../YouSpinner/YouSpinner';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const YouLoadingSpinner = ({ src, size = '20px', ...rest }) => (
  <YouSpinner size={size} {...rest} />
);

YouLoadingSpinner.propTypes = {
  src: PropTypes.string,
  size: PropTypes.string,
};

export const YouLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 74px;
  gap: 8px;
  margin: auto;
  animation: ${fadeIn} 300ms ease-in;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
